import type { ReactElement } from 'react';
import { Icon } from '@/components/shared/icon';
import type { IconName } from '@/components/shared/icon/icon-map';
import { iconMap } from '@/components/shared/icon/icon-map';
import { Stack, Typography } from '@mui/material';

type ToggleContentProps = {
  title: string;
  description?: string;
  icon?: IconName | ReactElement;
};

export const ToggleContent = ({
  title,
  icon,
  description,
}: ToggleContentProps) => {
  const isAvailableIcon = icon && typeof icon === 'string' && icon in iconMap;

  return (
    <Stack textAlign="left" height="100%">
      {isAvailableIcon ? <Icon name={icon} size={36} /> : icon}
      <Typography variant="h3" mt={icon && 2} mb={description && 1}>
        {title}
      </Typography>
      <Typography>{description}</Typography>
    </Stack>
  );
};
